module.exports = __webpack_public_path__ + "static/media/trash.aecdabd8.svg";